import { Animation } from 'blaze-components/Animations/Animation'
import analyzing from './analyzing.json'
import brand from './brand.json'
import styles from './styles.json'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './BrandVisualAnalysisProcessingModal.module.scss'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'

interface Props {
  cycle: number
  onCancel?: () => void
}

export const Processing = ({ cycle, onCancel: propsOnCancel }: Props) => {
  const { closeModal } = useModals()
  const onCancel = propsOnCancel ? propsOnCancel : () => closeModal()

  let step = 0

  if (cycle > 5) {
    step = 1
  }

  if (cycle > 10) {
    step = 2
  }

  const animationProps = { play: true, style: { width: 85, height: 85 } }

  return (
    <div className={Styles.content}>
      <div />
      <div className={Styles.animation}>
        {step === 0 && (
          <>
            <Animation animationData={analyzing} {...animationProps} />
            <Text variant="primary">Analyzing your content...</Text>
          </>
        )}
        {step === 1 && (
          <>
            <Animation animationData={styles} {...animationProps} />
            <Text variant="primary">Creating styles...</Text>
          </>
        )}
        {step === 2 && (
          <>
            <Animation animationData={brand} {...animationProps} />
            <Text variant="primary">Finalizing brand styles...</Text>
          </>
        )}
      </div>

      <div className={Styles.buttonContainer}>
        <Button variant="tertiary" onPress={onCancel} size="lg">
          Cancel
        </Button>
      </div>
    </div>
  )
}
